<template>
  <div class="orderPage">
     <Slider></Slider>
     <Header></Header>
     <Order></Order>
  </div>
   
  </el-container>
</template>

<script>
  import Slider from '@/components/layout/slider.vue';
  import Header from '@/components/layout/header.vue';
  import Order from '../order.vue';

  export default {
    data() {
      return {
        
      }
    },
    computed: {
      
    },
    methods:{
      
    },
    components:{
      Header,Slider,Order
    }
  };
</script>

<style scoped lang="scss">
  .aside{
    float: left;
  }
  .el-header{
    margin-left: 2.87rem;
    }
  .order{
    float: left;
    margin: 0.22rem 0 0 0.31rem;
  }
</style>




// WEBPACK FOOTER //
// src/views/orderPage/Order.vue